import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'
import localStorageService from './localStorageService'

class DashboardService extends BaseService {


    async getIncidetSummary(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.INCIDENT_SUMMARY, null, defaultParams)
    }

    async getIncidetReportByDailyWeekly(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.INCIDENT_REPORT, null, defaultParams)
    }
    async getIncidetByLocation(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.INCIDENT_BY_LOCATION, null, defaultParams)
    }

    async getImportantStatus(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.IMPORTANT_REPORT, null, defaultParams)
    }

    async getIncidentStatusCount(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.INCIDENT_STATUS_COUNT, null, defaultParams)
    }

    async getTypeCount(params) {
        const user = await localStorageService.getItem('user')
        const defaultParams = {
            company_id: user?.company_id,
            ...params
        }
        return await super.makeApiCall('GET', apiroutes.INCIDENT_TYPE_COUNT, null, defaultParams)
    }

}


// Create instance and export it
const DashboardServices = new DashboardService()
export default DashboardServices